<script>
import BaseButtonGroup from "../ui/BaseButtonGroup.vue";

export default {
  name: 'ButtonSelector',
  components: { BaseButtonGroup },
  props: {
    value: Array,
    presets: Array,
  },
  computed: {
    presetsOptions() {
      return this.presets.map((preset) => preset.label);
    },
    activePreset() {
      const value = [...this.value].sort().join();
      const activePreset = this.presets.find((preset) => preset.options.sort().join() === value);
      return (activePreset) ? activePreset.label : null;
    },
  },
  methods: {
    setActivePreset(e) {
      const preset = this.presets.find((preset) => preset.label === e);

      if (preset) {
        this.$emit('input', preset.options);
      }
    },
  },
};
</script>

<template lang="pug">
  .selector
    BaseButtonGroup(:value="activePreset" :options="presetsOptions" @input="setActivePreset")
</template>

<style scoped lang="scss">
.selector {
  display: flex;
}
</style>
